// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"Footer_footerContainer__lmp0f","videoContainer":"Footer_videoContainer__1zZXO","video":"Footer_video__2aOZR"};